export const agreementKeys = {
  agreement: () => ['agreement'] as const,
  agreements: () => ['agreements'] as const,
  requisite: () => ['requisite'] as const,
  checkAgreement: () => ['check-agreement'] as const,
};
